import { WorkspacePlaceholder } from './WorkspacePlaceholder';
import { WorkspaceShell } from './WorkspaceShell';

export function CollaborationWorkspace(): JSX.Element {
  return (
    <WorkspaceShell title="Coordinacion" status="future">
      <WorkspacePlaceholder
        title="Coordinacion"
        description="Organizar tareas, comentarios, seguimiento y decisiones vinculadas al proyecto."
        capabilities={[
          'Tareas y responsables',
          'Comentarios vinculados a entidades',
          'Seguimiento de decisiones',
          'Conversaciones por proyecto',
          'Historial de actividad',
        ]}
      />
    </WorkspaceShell>
  );
}
